import { render, staticRenderFns } from "./PaytStatLtr.vue?vue&type=template&id=5a81cc22&"
import script from "./PaytStatLtr.vue?vue&type=script&lang=js&"
export * from "./PaytStatLtr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports